export const fetchAssignmentsAction = (assignments) => {
  return {
    type: "FETCH_PATIENT_ASSIGNMENTS",
    payload: assignments,
  };
};

export const fetchGroupAssignmentsAction = (assignments) => {
  return {
    type: "FETCH_GROUP_ASSIGNMENTS",
    payload: assignments,
  };
};

export const addPatientAssignmentAction = (assignment) => {
  return {
    type: "ADD_PATIENT_ASSIGNMENT",
    payload: assignment,
  };
};

export const addGroupAssignmentAction = (assignment) => {
  return {
    type: "ADD_GROUP_ASSIGNMENT",
    payload: assignment,
  };
};

export const deletePatientAssignmentAction = (assignment) => {
  return {
    type: "DELETE_PATIENT_ASSIGNMENT",
    payload: assignment,
  };
};

export const deleteGroupAssignmentAction = (assignment) => {
  return {
    type: "DELETE_GROUP_ASSIGNMENT",
    payload: assignment,
  };
};

export const updateNotificationAction = (notification) => {
  return {
    type: "UPDATE_NOTIFICATION",
    payload: notification,
  };
};

export const updateGroupNotificationAction = (notification) => {
  return {
    type: "UPDATE_GROUP_NOTIFICATION",
    payload: notification,
  };
};

export const updatePatientAssignment = (assignment) => {
  return {
    type: "UPDATE_PATIENT_ASSIGNMENT",
    payload: assignment,
  };
};

export const updateGroupAssignment = (assignment) => {
  return {
    type: "UPDATE_GROUP_ASSIGNMENT",
    payload: assignment,
  };
};

export const updateUnsavedReminderSettings = (settings) => {
  return {
    type: "UPDATE_UNSAVED_REMINDER_SETTINGS",
    payload: settings,
  };
};

export const updateUnsavedConfigureSettings = (settings) => {
  return {
    type: "UPDATE_UNSAVED_CONFIGURE_SETTINGS",
    payload: settings,
  };
};

export const invalidateAssignmentCache = () => {
  return {
    type: "INVALIDATE_ASSIGNMENT_CACHE",
  };
};

export const invalidateGroupAssignmentCache = () => {
  return {
    type: "INVALIDATE_GROUP_ASSIGNMENT_CACHE",
  };
};
